import type { FC } from 'react';
import React from 'react';
import cn from 'classnames';

import { CityTag } from '../city-tag';
import { noop } from '../../helpers';

import type { ITagsTopCities } from './models';
import styles from './styles.css';

export const TagsTopCities: FC<ITagsTopCities> = ({
    className,
    onClick = noop,
    topCities,
    autoDetectedFiasId,
}) => (
    <ul className={cn(className, styles.tagsTopCities)}>
        {topCities.map(city => (
            <CityTag
                key={city.fiasId}
                cityName={city.cityNameRus}
                onClick={() => onClick(city)}
                showGeoIcon={city.fiasId === autoDetectedFiasId}
            />
        ))}
    </ul>
);
